import * as types from './actionTypes';

const initialState = {
  quality: 'unknown', // healthy | degraded | poor | offline | unknown
  stats: {
    windowMs: 0,
    isOnline: null,
    connection: null
  },
  toast: null // { text, quality, at }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.NETWORK_QUALITY_UPDATE:
      return {
        ...state,
        quality: action.payload.quality || 'unknown',
        stats: action.payload.stats || initialState.stats
      };
    case types.NETWORK_QUALITY_TOAST_SHOW:
      return {
        ...state,
        toast: action.payload
      };
    case types.NETWORK_QUALITY_TOAST_CLEAR:
      return {
        ...state,
        toast: null
      };
    default:
      return state;
  }
};

const quality = state => state.quality || 'unknown';
const stats = state => state.stats || initialState.stats;
const toast = state => state.toast || null;

const networkSelectors = {
  quality,
  stats,
  toast
};

export default reducer;
export { networkSelectors };
